import _ from 'lodash';
import globalStore from '$$globalStore';
import app from '$$app';
import { createAttachmentsHelper } from './helpers';

function onTaskAttachementCreated(event) {
  const tasksToUpdateMap = {};

  createAttachmentsHelper(event.data.attachments);

  event.data.attachments.forEach(attachment => {
    const taskData = globalStore.getters['tasksModel/getTaskByGanttId'](attachment.projectId, attachment.taskId);

    if (!taskData) {
      return;
    }

    const hasAttachments = tasksToUpdateMap[attachment.taskId] ? tasksToUpdateMap[attachment.taskId].hasAttachments + 1 : +(taskData.hasAttachments || 0) + 1;

    tasksToUpdateMap[attachment.taskId] = {
      id: +attachment.taskId,
      gantt_id: +taskData.gantt_id,
      hasAttachments,
    };
  });

  if (!_.isEmpty(tasksToUpdateMap)) {
    globalStore.commit('tasksModel/updateTasks', { tasks: Object.values(tasksToUpdateMap), fromGantt: false }, { root: true });
  }

  app.trigger('onAfterCollaboration', {
    event: event.event,
    tasks: event.data.attachments.map(i => i.taskId),
  });
}

export default onTaskAttachementCreated;
